{
  "date": "{{month}} {{day}}, {{year}}",
  "header": "Congratulations, {{firstName}}! The agent is currently processing your transaction.",
  "noDownPayment": {
    "last4": "<p>You may see a $0 charge on your account ending in <strong>{{last4}}</strong> for authentication purposes.</p>",
    "noLast4": "<p>You may see a $0 charge on your account for authentication purposes.</p>"
  },
  "downPayment": {
    "last4": "<p>Your payment plan is good to go. Today, we'll charge <strong><downPayment /></strong> to your card ending in <strong>{{last4}}</strong>.</p>",
    "noLast4": "<p>Your payment plan is good to go. Today, we'll charge <strong><downPayment /></strong> to your card.</p>"
  },
  "continue": "Continue",
  "uplift": {
    "payLink": "https://pay.uplift.com",
    "starting-next-month": "<p>Your first monthly payment of <monthlyPaymentAuto><monthlyPayment /></monthlyPaymentAuto> will be due on <firstPaymentDateAuto><dueDate/></firstPaymentDateAuto>. Don't worry, Uplift will notify you before each payment is due.</p>",
    "manage-loan": "<p>You can always manage your loan, view upcoming payments, or ask us any questions at <0>pay.uplift.com</0>. Just log in using your phone number.</p>",
    "thank-you": "<p>Thank you for choosing Uplift!</p>"
  },
  "flexpay": {
    "payLink": "https://upgrade.com/pay",
    "starting-next-month": "<p>Your first monthly payment of <monthlyPaymentAuto><monthlyPayment /></monthlyPaymentAuto> will be due on <firstPaymentDateAuto><dueDate/></firstPaymentDateAuto>. Don't worry, Flex Pay will notify you before each payment is due.</p>",
    "manage-loan": "<p>You can always manage your loan, view upcoming payments, or ask us any questions at <0>upgrade.com/pay</0>. Just log in using your phone number!</p>",
    "thank-you": "<p>Thank you for using Flex Pay!</p>"
  }
}
